/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Contract_Phases_DuplicateInputs */

const en_clients_validation_contract_phases_duplicate = /** @type {(inputs: Clients_Validation_Contract_Phases_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each phase can only be added once per case type.`)
};

const pt_br2_clients_validation_contract_phases_duplicate = /** @type {(inputs: Clients_Validation_Contract_Phases_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada fase pode ser adicionada apenas uma vez por tipo de caso.`)
};

/**
* | output |
* | --- |
* | "Each phase can only be added once per case type." |
*
* @param {Clients_Validation_Contract_Phases_DuplicateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_contract_phases_duplicate = /** @type {((inputs?: Clients_Validation_Contract_Phases_DuplicateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Contract_Phases_DuplicateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_contract_phases_duplicate(inputs)
	return pt_br2_clients_validation_contract_phases_duplicate(inputs)
});